import store from '../store'
import {objectToEncodedQueryString} from '@/utils/utils';

const gotoAdobeService = () => {
  let contacts = store.getters['CONTACTS/contacts'],
      client = store.getters['CLIENT/client'],
      analysis = store.getters['ANALYSIS/analysis'];

  let query = {
    clientFullName: `${contacts.firstName} ${contacts.lastName}`,
    taxYear: analysis.analysisResults.subjectProperty.taxYear,
    phone: contacts.phone,
    email: contacts.email,
    totalAV:  analysis.analysisResults.subjectProperty.totalAssessment,
    propertyFullAddress: analysis.analysisResults.subjectProperty.fullAddress,
    township: analysis.analysisResults.subjectProperty.townshipName,
    county: analysis.analysisResults.subjectProperty.countyName,
    flatFee: client.appealFlatFee,
    processingFee: Math.round(client.discountPercent * 10000)/100,
    contingencyFee : Math.round(client.contingencyFeePercent * 10000)/100,
    propertyAddressLine1: analysis.analysisResults.subjectProperty.addressLine1,
    city: analysis.analysisResults.subjectProperty.city,
    state: analysis.analysisResults.subjectProperty.state,
    zip: analysis.analysisResults.subjectProperty.zipCode,
  };

  let pins = analysis.analysisResults.subjectProperty.formattedPin.split(',');
  query.formattedPin = pins[0];
  if(pins.length > 1) {
    query.formattedPin2 = pins[1];
  }

  if (analysis.pdfPurchase.pprice) {
    query.pprice = analysis.pdfPurchase.pprice
  }
  if (analysis.pdfPurchase.pdate) {
    query.pdate = analysis.pdfPurchase.pdate
  }
  window.open(`${client.digitalSignaturePackageUrl}#${objectToEncodedQueryString(query)}` , '_blank');
}

export {
  gotoAdobeService
}